export default "__VITE_ASSET__BWK3tMHO__"